import React from 'react'

import ContentfulImageLink from '@src/quince-site-common/src/domains/contentful/ContentfulImageLink'
import { Image } from '../image'

import { Link } from '..'
import ContentfulLink from '@src/quince-site-common/src/domains/contentful/ContentfulLink'

export interface SocialBoxProps {
  footerSocial: ContentfulImageLink[]
}

const SocialBox = (props: SocialBoxProps) => {
  return (
    <div className="column-gap--2">
      {props.footerSocial.map(fs => {
        return (
          <Link href={ContentfulLink.getLinkPath(fs.link)} key={fs.link.text}>
            <Image title={fs.images[0].title || ''} url={fs.images[0].file.url} useNative />
          </Link>
        )
      })}
    </div>
  )
}

export default SocialBox
